// Same in every environment: the form lives on the Brimit SharePoint tenant, not on the app site.
export const EXTERNAL_LINKS = {
    FEEDBACK_FORM:
        'https://brimitglobal.sharepoint.com/:l:/g/JAAeF4-fUxh7RLZJvvjlH2WiAa-G47pUE5HWfPKQC6bRfo8?nav=NmIyNTM4ZjMtYzgyMS00OGQzLWI5YzgtOWFmZTJhMWQyMTdi',
} as const;
